import React from 'react';
import PropTypes from 'prop-types';

import {
    Typography,
    Link,
} from '../Wrappers/Wrappers.jsx';
import { DefaultURLs } from '../../utils/constants';

function TermsConsentNotice ({ marginBottom }) {
    return (
        <Typography variant={'body2'} weight={'light'} style={{ marginBottom }}>
            By proceeding, you agree to the{' '}
            <Link
                href={DefaultURLs.SAAS_TERMS}
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
            >
                ECAL Licence Terms
            </Link>.
        </Typography>
    );
}

TermsConsentNotice.propTypes = {
    marginBottom: PropTypes.number,
};

TermsConsentNotice.defaultProps = {
    marginBottom: 24,
};

export default TermsConsentNotice;
